module.exports = __webpack_public_path__ + "static/bankier-52b67dcf9946fa03961c9f814b56b282.jpg";